import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.to-string.js";
import React, { Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import DetailsDropdown from 'components/ContentInfo/DropdownInfo';
import CurationItem from './CurationItem';
import { jsx as _jsx } from "react/jsx-runtime";
function CurationDropdown(_ref) {
  var data = _ref.data,
    children = _ref.children;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/_jsx(DetailsDropdown, {
    titleKey: "panel_curation_checklist_title",
    listLayout: "stack",
    listItems: data.map(function (item) {
      return /*#__PURE__*/_jsx(Fragment, {
        children: /*#__PURE__*/_jsx(CurationItem, {
          isComplete: item.exists,
          children: t(item.fieldTranslationKey)
        })
      }, item.fieldTranslationKey);
    }),
    children: children
  });
}
export default CurationDropdown;